module.exports = __webpack_public_path__ + "img/CS26Q-中_10.19aa02ec.jpg";